export const OPEN_DRAWER = "OPEN_DRAWER";
export const CLOSE_DRAWER = "CLOSE_DRAWER";
export const TOGGLE_DRAWER = "TOGGLE_DRAWER";
export const REFRESH = "REFRESH";